import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import { EDIT_APARTMENT, EDIT_B2BALLIANCE, EDIT_CORPORATE } from './type';

export const editCorporateLeadSubmit = (val) => async (dispatch) => {
  const {
    sourceLead,
    leadCatId,
    contact_date,
    name,
    building_name,
    currentLocation,
    email,
    secondContact,
    islocationType,
    pocVal,
    pocName,
    fmcName,
    pocDesVal,
    number,
    isLat,
    isLong,
    area,
    zone,
    city,
    geoStateId,
    geoCityId,
    pinId,
    address1,
    address2,
    leadId,
    gatesNo,
    slotsNo,
    fcfsSlots,
    supplyName,
    reservedSlots,
    vms,
    gates,
    evChargersNo,
    mailCamp,
    occupancy,
    existing_setup,
    marquee_site,
    partners,
    products
  } = val;
  const data = {
    lead_id: `${leadId}`,
    contact_date:`${contact_date}`,
    client_name: `${name}`,
    building_name: `${building_name}`,
    lead_source_id: `${sourceLead}`,
    lead_category_id: `${leadCatId}`,
    current_location: `${currentLocation}`,
    tp_poc_site_id: `${pocVal}`,
    poc_name: `${pocName}`,
    fmc_name: `${fmcName}`,
    poc_designation: `${pocDesVal}`,
    poc_phone_number: `${number}`,
    poc_email: `${email}`,
    poc_secondary_contact: `${secondContact}`,
    supply_id: supplyName,
    location_type: `${islocationType}`,
    latitude: isLat,
    longitude: isLong,
    area_id: area,
    zone_id: zone,
    city_id: city,
    geo_state: geoStateId,
    geo_city: geoCityId,
    geo_pincode: pinId,
    no_of_slots: slotsNo,
    no_of_gates: gatesNo,
    fcfs_slots: fcfsSlots,
    address_line_one: `${address1}`,
    address_line_two: `${address2}`,
    reserved_slots: reservedSlots,
    vms_type: vms,
    gate_details: gates,
    no_of_evchargers: evChargersNo,
    mail_campaign: mailCamp.value,
    occupancy: occupancy,
    existing_setup: existing_setup,
    marquee_site: marquee_site,
    partners: partners,
    products: products
  };
  const res = await callWebService(
    callTypes.put,
    data,
    Config.editLead.corporate
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: EDIT_CORPORATE, payload: data.response.data });
    return true;
  }
};

export const editApartmentLeadSubmit = (val) => async (dispatch) => {
  // console.log(val);
  const {
    sourceLead,
    alternateChannle,
    mainSource,
    otherSource,
    leadCatId,
    contact_date,
    name,
    currentLocation,
    email,
    secondContact,
    islocationType,
    pocVal,
    pocName,
    pocDesVal,
    number,
    isLat,
    isLong,
    area,
    zone,
    city,
    geoStateId,
    geoCityId,
    pinId,
    slotsNo,
    gatesNo,
    address1,
    address2,
    avgChFlat,
    // date,
    flatNo,
    // rwaTenure,
    carsNo,
    HelpStaffNo,
    leadId,
    supplyName,
    interactionTypeLead,
    societyType,
    gateType,
    vms,
    existingGates,
    occupancy,
    disputeLevel,
    societyUpkeeping,
    amenities,
    managedBy,
    maintainanceCharges,
    leadSourceOther,
    securityAgency,
    gates
  } = val;
  const data = {
    lead_id: `${leadId}`,
    lead_source_id: `${sourceLead}`,
    alternateChannle: alternateChannle,
    mainSource: mainSource,
    otherSource: otherSource,
    other_lead_source: `${leadSourceOther}`,
    contact_date:`${contact_date}`,
    lead_category_id: `${leadCatId}`,
    client_name: `${name}`,
    current_location: `${currentLocation}`,
    location_type: `${islocationType}`,
    tp_poc_site_id: `${pocVal}`,
    poc_name: `${pocName}`,
    poc_designation: `${pocDesVal}`,
    poc_phone_number: `${number}`,
    poc_email: `${email}`,
    poc_secondary_contact: `${secondContact}`,
    supply_id: supplyName,
    latitude: `${isLat}`,
    longitude: `${isLong}`,
    area_id: `${area}`,
    zone_id: `${zone}`,
    city_id: `${city}`,
    geo_state: `${geoStateId}`,
    geo_city: `${geoCityId}`,
    geo_pincode: pinId,
    no_of_slots: `${slotsNo}`,
    no_of_gates: `${gatesNo}`,
    no_of_flats: `${flatNo}`,
    no_of_staff: `${HelpStaffNo}`,
    no_of_cars: `${carsNo}`,
    // rwa_end_date: `${date}`,
    // rwa_tenure: `${rwaTenure}`,
    rwa_maintenance_charge: `${avgChFlat}`,
    address_line_one: `${address1}`,
    address_line_two: `${address2}`,
    lead_interaction_type_id: interactionTypeLead,
    society_type: societyType,
    gate_type: gateType,
    vms_type: vms,
    existing_gates: existingGates,
    occupancy: occupancy,
    dispute_level: disputeLevel,
    society_upkeeping: societyUpkeeping,
    amenities: amenities,
    managed_by: managedBy,
    maintainance_charges: maintainanceCharges,
    security_agency: securityAgency,
    gate_details: gates
  };
  const res = await callWebService(
    callTypes.put,
    data,
    Config.editLead.apartment
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: EDIT_APARTMENT, payload: data.response.data });
    return true;
  }
};

export const editAllianceLeadSubmit = (val) => async (dispatch) => {
  const {
    sourceLead,
    name,
    currentLocation,
    email,
    secondContact,
    islocationType,
    pocName,
    pocDesVal,
    number,
    isLat,
    isLong,
    area,
    zone,
    city,
    geoStateId,
    geoCityId,
    pinId,
    address1,
    address2,
    leadId,
    remarks,
    tpPoc,
  } = val;
  const data = {
    lead_id: `${leadId}`,
    lead_source_id: `${sourceLead}`,
    lead_category_id: 13,
    client_name: `${name}`,
    poc_name: `${pocName}`,
    poc_designation: `${pocDesVal}`,
    poc_phone_number: `${number}`,
    poc_email: `${email}`,
    poc_secondary_contact: `${secondContact}`,
    current_location: `${currentLocation}`,
    location_type: `${islocationType}`,
    latitude: `${isLat}`,
    longitude: `${isLong}`,
    area_id: area,
    zone_id: zone,
    city_id: city,
    geo_state: geoStateId,
    geo_city: geoCityId,
    geo_pincode: pinId,
    address_line_one: `${address1}`,
    address_line_two: `${address2}`,
    remarks: `${remarks}`,
    tp_poc_site_id: `${tpPoc}`,
  };
  const res = await callWebService(
    callTypes.put,
    data,
    Config.editLead.b2bAlliance
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: EDIT_B2BALLIANCE, payload: data.response.data });
    return true;
  }
};

export const editSupplyLeadSubmit = (val) => async (dispatch) => {
  console.log(val);
  const {
    name,
    sourceLead,
    typeSite,
    typeSubSite,
    pocName,
    pocDesVal,
    number,
    email,
    currentLocation,
    islocationType,
    isLat,
    isLong,
    area,
    zone,
    city,
    geoStateId,
    geoCityId,
    pinId,
    address1,
    address2,
    carSlots,
    bikeSlots,
    otherSlots,
    occupancyCar,
    occupancyBike,
    entryGates,
    exitGates,
    parkingFloors,
    parkingRevenue,
    securityAgency,
    parkingAgency,
    leadId,
  } = val;

  const data = {
    lead_id: `${leadId}`,
    client_name: `${name}`,
    lead_source_id: `${sourceLead}`,
    site_type_id: `${typeSite}`,
    site_sub_type_id: `${typeSubSite}`,
    poc_name: `${pocName}`,
    poc_designation: `${pocDesVal}`,
    poc_phone_number: `${number}`,
    poc_email: `${email}`,
    current_location: `${currentLocation}`,
    location_type: islocationType,
    latitude: `${isLat}`,
    longitude: `${isLong}`,
    area_id: area,
    zone_id: zone,
    city_id: city,
    geo_state: `${geoStateId}`,
    geo_city: `${geoCityId}`,
    geo_pincode: `${pinId}`,
    address_line_one: `${address1}`,
    address_line_two: `${address2}`,
    car_slots: `${carSlots}`,
    bike_slots: `${bikeSlots}`,
    other_slots: `${otherSlots}`,
    occup_car: occupancyCar?.id,
    occup_bike: occupancyBike?.id,
    entry_gates: `${entryGates}`,
    exit_gates: `${exitGates}`,
    parking_floors: `${parkingFloors}`,
    parking_rev: `${parkingRevenue}`,
    sec_agency: `${securityAgency}`,
    park_agency: `${parkingAgency}`,
  };
  const res = await callWebService(callTypes.put, data, Config.editLead.supply);
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: EDIT_B2BALLIANCE, payload: data.response.data });
    return true;
  }
};
